import React, { Component } from "react";

import Enemy_01 from "../../images/GameTheme/RoleComponent/Enemy_01.png";
import Enemy_02 from "../../images/GameTheme/RoleComponent/Enemy_02.png";
import Enemy_03 from "../../images/GameTheme/RoleComponent/Enemy_03.png";
import Enemy_04 from "../../images/GameTheme/RoleComponent/Enemy_04.png";
import Enemy_05 from "../../images/GameTheme/RoleComponent/Enemy_05.png";
import Enemy_06 from "../../images/GameTheme/RoleComponent/Enemy_06.png";
import Enemy_07 from "../../images/GameTheme/RoleComponent/Enemy_07.png";
import Enemy_08 from "../../images/GameTheme/RoleComponent/Enemy_08.png";
import Enemy_09 from "../../images/GameTheme/RoleComponent/Enemy_09.png";

class Enemy extends Component {
    render() {
        const manday = this.props.manday;

        return (
            <div>
                {renderEnemy(Number(manday))}
            </div>
        );
    }
}

function renderEnemy(value) {
    if (value === 0) {
        return <img src={Enemy_01} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 0 && value <= 1) {
        return <img src={Enemy_02} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 1 && value <= 2) {
        return <img src={Enemy_03} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 2 && value <= 3) {
        return <img src={Enemy_04} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 3 && value <= 5) {
        return <img src={Enemy_05} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 5 && value <= 8) {
        return <img src={Enemy_06} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 8 && value <= 13) {
        return <img src={Enemy_07} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 13 && value <= 21) {
        return <img src={Enemy_08} alt="..." style={getEnemyStyle()} />;
    }
    if (value > 21) {
        return <img src={Enemy_09} alt="..." style={getEnemyStyle()} />;
    }
}

function getEnemyStyle(){
    return {
        position: 'absolute',
        height: '180px',
        left: '350px',
        bottom: '30px',
        zIndex: 1,
    }
}

export default Enemy;


// WEBPACK FOOTER //
// ./src/components/Game/Enemy.js